import React from 'react';
import { Link } from 'react-router-dom';

interface ToolCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  to: string;
  color: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, icon, to, color }) => {
  return (
    <Link 
      to={to}
      className={`block p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ${color} text-white`}
    >
      <div className="flex flex-col items-center text-center">
        <div className="p-3 rounded-full bg-white bg-opacity-20 mb-4">
          {icon}
        </div>
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="opacity-90">{description}</p>
      </div>
    </Link>
  );
};

const ModelhanePanel: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Modelhane Paneli</h1>
        <p className="text-gray-600">Tüm modelhane araçlarına buradan erişebilirsiniz.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Kalıp Yönetimi */}
        <ToolCard
          title="Kalıp Yönetimi"
          description="Kalıp oluşturma ve düzenleme işlemleri"
          to="/modelhane/kalip"
          color="bg-gradient-to-br from-violet-500 to-purple-500"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
          }
        />
        
        {/* Üretim Dosyaları */}
        <ToolCard
          title="Üretim Dosyaları"
          description="Üretim için teknik çizimler ve dosyalar"
          to="/modelhane/uretim-dosyalari"
          color="bg-gradient-to-br from-blue-500 to-indigo-500"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          }
        />
        
        {/* Prototip Yönetimi */}
        <ToolCard
          title="Prototip Yönetimi"
          description="Numune üretimi ve prototip takibi"
          to="/modelhane/prototip"
          color="bg-gradient-to-br from-emerald-500 to-green-600"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default ModelhanePanel;
